import { Outlet, createFileRoute } from "@tanstack/react-router";
import { AppShell } from "@/components/AppShell";

export const Route = createFileRoute("/disputes")({
  component: () => (
    <AppShell>
      <Outlet />
    </AppShell>
  ),
});
